module.exports = ".half-checked /deep/ .pi-check::before {\n  content: \"\\e90f\"; }\n"